export default {
  getQueryObject() {
    let queryObject = {};
    $.each(document.location.search.substr(1).split('&'), function (c, q) {
      let i = q.split('=');
      if (i[0] !== undefined && i[1] !== undefined) {
        queryObject[i[0].toString()] = i[1].toString();
      }
    });

    return queryObject;
  },

  init() {
    let self = this;
    $('ul.pagination li a').click(function (e) {
      e.preventDefault();
      // URL original
      let href = $(this).attr('href');
      // Query strings actuales
      let qObject = self.getQueryObject();
      // Elimina la pagina del query string original
      delete qObject['page'];
      // Transforma el objecto a un query string del tipo param=1&param=2&param=3
      let queryString = Object.keys(qObject).map(k => k + '=' + qObject[k]).join('&');
      // Agrega el query string actual al link
      window.location.href = href + '&' + queryString;
    });
  },
};
